import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// current User Details
export const GetRemotePanel = createAsyncThunk(
  "remotepanel/getRemotePanel",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/remote-pannel/admin/${data.id}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      // Check if the login is successful
      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during remote panel data.";
      return rejectWithValue(errorMessage);
    }
  }
);

// save a new user
export const saveRemotePanel = createAsyncThunk(
  "remotecontrol/saveRemoteControl",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/remote-pannel/new`,
        data,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      // Check if the login is successful
      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during adding remote-panel.";
      return rejectWithValue(errorMessage);
    }
  }
);

// get all the users --admin
export const getAllRemotePanel = createAsyncThunk(
  "remotepanel/getAllRemotePanel",
  async (data, { rejectWithValue }) => {
    try {

      console.log('getting data from remotepanel')

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/remote-pannel/all`,
        data,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
        // {
        //   headers: { Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY3NDQ3MjRiZWRjYjU5YjQ2NzMxM2FhYyIsInJlZnJlc2hUb2tlbiI6ImMyYTI1OThhOWE1MDUxMjAiLCJpYXQiOjE3MzI2MjcxMzYsImV4cCI6MTczMjcxMzUzNn0.--cyDg0YrNo75GztH0edknspRD40Cn9fCUVkbqcn4EM` },
        // }
      );

       console.log('getting data of remote-panel ', response?.data)
      // Check if the login is successful
      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data?.result;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "getting error during  save data of remote-panel.";
      return rejectWithValue(errorMessage);
    }
  }
);

// update a user  --admin
export const updateRemotePanel = createAsyncThunk(
  "remotepanel/updateRemotePanel",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/remote-pannel/admin/${data.id}`,
        data.data,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during update remote-panel.";
      return rejectWithValue(errorMessage);
    }
  }
);




export const blockRemotePanel = createAsyncThunk(
  "remotepanel/blockRemotePanel",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/remote-pannel/admin/${data.id}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during delete remote-panel.";
      return rejectWithValue(errorMessage);
    }
  }
);



